export const sources={webp:"__VITE_ASSET__MLyWSxi5__ 60w"};export const img={src:"__VITE_ASSET__Be61wBUl__",w:60,h:60};export default{sources:sources,img:img};